import classNames from 'classnames';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import PaymentAutocomplite from '../../../common/PaymentAutocomplite';
import ApplePaymentButton from './ApplePaymentButton';
import GooglePaymentButton from './GooglePaymentButton';
import styles from './styles.module.scss';

export const NATIVE_METHOD_PAYMENT_TYPE = {
    GOOGLE: 'google',
    APPLE: 'apple'
};

const NativePaymentButton = ({ price, paymentDispatch, nativePaymentType, paymentTexts = '', showDivider = false }) => {
    const { t } = useTranslation();
    const [countryCode, setCountryCode] = useState('US');
    const [hidden, setHidden] = useState(nativePaymentType === NATIVE_METHOD_PAYMENT_TYPE.APPLE);
    console.log('nativePaymentType', nativePaymentType);

    return (
        <>
            {showDivider && !hidden && (
                <div className={styles.divider}>
                    <span></span>
                    <span className={styles.dividerText}>OR</span>
                    <span></span>
                </div>
            )}
            <div className={classNames(styles.googlePay, { [styles.hidden]: hidden })}>
                <div className={styles.select}>
                    <span className={styles.label}>{t('labels.chooseCountry') + ' *'}</span>
                    <PaymentAutocomplite countryCode={countryCode} setCountryCode={setCountryCode} />
                </div>
                {nativePaymentType === NATIVE_METHOD_PAYMENT_TYPE.GOOGLE && (
                    <GooglePaymentButton price={price} countryCode={countryCode} paymentDispatch={paymentDispatch} />
                )}
                {nativePaymentType === NATIVE_METHOD_PAYMENT_TYPE.APPLE && (
                    <div className={styles.margin}>
                        <ApplePaymentButton
                            price={price}
                            countryCode={countryCode}
                            paymentDispatch={paymentDispatch}
                            paymentTexts={paymentTexts}
                            setHidden={setHidden}
                        />
                    </div>
                )}
            </div>
        </>
    );
};

export default NativePaymentButton;
